var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "实名认证",
        footer: null,
        width: 420,
        closable: false,
        keyboard: false,
        maskClosable: false
      },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "16px",
            color: "#0d253e",
            "text-align": "center"
          }
        },
        [_vm._v(_vm._s(_vm.des))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter", staticStyle: { margin: "24px 0" } },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.okModal } },
            [_vm._v("立即认证")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7a626c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7a626c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aprv-status/aprv-status-dialog.vue
// module id = ir6O
// module chunks = 1